import { render, staticRenderFns } from "./CurePlanDelete.vue?vue&type=template&id=7a74e409&scoped=true&"
import script from "./CurePlanDelete.vue?vue&type=script&lang=js&"
export * from "./CurePlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a74e409",
  null
  
)

export default component.exports